import * as actionTypes from '../Register_action.types';

const initialState = {
  loggingIn: false,
  employees: [],
  error: null,
  message: '',
};
const FormReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_FORM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.GET_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        employees: action.payload,

      }

    case actionTypes.GET_FORM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default FormReducer
